// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_57c154fb","outerContainer":"_5b74d305","secondaryToolbar":"a3466813","doorHangerRight":"f1341770","toolbarContainer":"_8124da40","toolbarViewerMiddle":"a2b2f841","progressBar":"_87524cbc","back-to-application":"_12c20330","wrapper":"_842aa153","content":"fe57e890","icon":"_3e1baa13","text":"fd20b901"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualRoom/styles.styl
// module id = 5151
// module chunks = 39